module.exports = __webpack_public_path__ + "img/delay.d5228be.png";